import { render, staticRenderFns } from "./instBoxConfirm.vue?vue&type=template&id=edacb066&scoped=true"
import script from "./instBoxConfirm.vue?vue&type=script&lang=js"
export * from "./instBoxConfirm.vue?vue&type=script&lang=js"
import style0 from "./instBoxConfirm.vue?vue&type=style&index=0&id=edacb066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edacb066",
  null
  
)

export default component.exports